import { Component, HostListener, Input, OnInit } from '@angular/core';
import { Patient } from 'src/app/core/entities/patient.entity';

@Component({
  selector: 'app-detail-info',
  templateUrl: './detail-info.component.html',
  styleUrls: ['./detail-info.component.css'],
})
export class DetailInfoComponent implements OnInit {
  @Input() public patientProfile: Patient = new Patient();
  public active = 'information';
  public screenWidth: number;
  public containerWidth: number;
  public trickLine: number;
  public newMargin: string;

  constructor() {}

  ngOnInit(): void {
    this.screenWidth = window.innerWidth;
    this.containerWidth = document.getElementById('container').offsetWidth;
    if (this.screenWidth >= 1200) {
      this.trickLine = this.screenWidth - (this.containerWidth + 384);
    } else {
      this.trickLine = this.screenWidth - (this.containerWidth + 294);
    }
    this.newMargin = '-' + this.trickLine + 'px';
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.screenWidth = window.innerWidth;
    this.containerWidth = document.getElementById('container').offsetWidth;
    if (this.screenWidth >= 1200) {
      this.trickLine = this.screenWidth - (this.containerWidth + 384);
    } else {
      this.trickLine = this.screenWidth - (this.containerWidth + 294);
    }
    this.newMargin = '-' + this.trickLine + 'px';
  }
}
